export class UsuarioListResponse {
    id!: number;
    nome!: string;
    cpf!: string;
    genero!: string;
    email!: string;
    telefone!: string;
    imobiliariaId: number;
    imobiliariaNome: string;
    perfilId!: number;
    flagAtivo!: boolean;

    constructor(p: any) {
        this.id = p.id ?? null;
        this.nome = p.nome ?? null;
        this.cpf = p.cpf ?? null;
        this.genero = p.genero ?? null;
        this.email = p.email ?? null;
        this.telefone = p.telefone ?? null;
        this.imobiliariaId = p.imobiliariaId ?? null;
        this.imobiliariaNome = p.imobiliariaNome ?? null;
        this.perfilId = p.perfilId ?? null;
        this.flagAtivo = !!p.flagAtivo;
    }
}